<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Дом {{ building.number }}
      <router-link class="btn btn-primary" :to="{ name: 'building-edit', params: { building_id: building.id }}">Редактировать дом</router-link>
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'address-details', params: { address_id: $route.params.address_id } }">← Назад к Домам</router-link>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Полный адрес</label>
          <p>{{ building.full_name }}</p>
        </div>

        <!-- Contract number prefixes -->
        <div class="form-group">
          <label>Префиксы номеров контрактов</label>
          <p>{{ building.contract_number_prefixes }} </p>
        </div>

      </div>
      <div class="col-md-6">

        <!-- Number -->
        <div class="form-group">
          <label>Номер дома</label>
          <p>{{ building.number }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :building-id="building.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getBuilding } from '@/services/building.service'

export default {
  name: 'building-details',
  data () {
    return {
      building: {
        id: null,
        number: '',
        contract_number_prefixes: '',
        full_name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.building_id !== undefined) {
      this.building.id = this.$route.params.building_id

      getBuilding(this.building.id).then((response) => {
        this.building = response.data
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// BuildingDetails.vue?447ec11d